import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import FormContainer from "../../../../../../common/components/form_container";
import DefaultFormInput from "../../../../../../common/components/default_form_input";
import { useEffect } from "react";
import PrimaryButton from "../../../../../../common/components/primary_button";
import { BaseFormControlledModal } from "../../../../../../common/components/base_form_controlled_modal";
import { LogTipoTabela } from "../../../../../../common/utils/log_tabela_tipo";
import { ChecklistServicoAmbienteModel } from "../../../../domain/models/checklist_servico_ambiente";
import { ChecklistServicoAmbienteCadastroForm, ChecklistServicoAmbienteCadastroSchema, defaultChecklistServicoAmbienteCadastroForm } from "../../../schemas/checklist_servico_ambiente_lista/checklistServicoAmbienteCadastro";


type props = {
    open: boolean,
    saving: boolean,
    loading: boolean,
    selectedChecklistServicoAmbiente?: ChecklistServicoAmbienteModel | null,

    handleOpenChangeHistory: (idTabela: number | null, tipoTabela: LogTipoTabela | null) => void
    onClose: () => void,
    onSubmit: (form: ChecklistServicoAmbienteCadastroForm) => void,
}

export const CadastroChecklistServicoAmbienteModal = ({
    open,
    saving,
    loading,
    selectedChecklistServicoAmbiente,

    handleOpenChangeHistory,
    onClose,
    onSubmit,
}: props) => {

    const hookFormCadastro = useForm<ChecklistServicoAmbienteCadastroForm>({
        mode: "onSubmit",
        reValidateMode: "onSubmit",
        defaultValues: defaultChecklistServicoAmbienteCadastroForm,
        resolver: zodResolver(ChecklistServicoAmbienteCadastroSchema),
    });

    useEffect(() => {
        if (selectedChecklistServicoAmbiente) {
            hookFormCadastro.setValue('idChecklistServico', selectedChecklistServicoAmbiente.idChecklistServico ?? 0);
            hookFormCadastro.setValue('ordem', selectedChecklistServicoAmbiente.ordem ?? '');
            hookFormCadastro.setValue('descricao', selectedChecklistServicoAmbiente.descricao ?? '');
        } else {
            hookFormCadastro.reset(defaultChecklistServicoAmbienteCadastroForm);
        }
        if (!open) {
            hookFormCadastro.reset(defaultChecklistServicoAmbienteCadastroForm);
        }
    }, [selectedChecklistServicoAmbiente, open, hookFormCadastro]);


    return (
        <BaseFormControlledModal
            open={open}
            saving={saving}
            loading={loading}
            title="Cadastro de Ambiente (Sala, cozinha, banheiro, outros)"
            onClose={onClose}
            leftButtonSlot={
                selectedChecklistServicoAmbiente &&
                <PrimaryButton
                    buttonColor="yellow"
                    onClick={() => handleOpenChangeHistory(selectedChecklistServicoAmbiente?.idChecklistServicoAmbiente ?? null, LogTipoTabela.CHECKLIST_SERVICO_AMBIENTE)}>
                    <span className="text-xs">
                        Historico de alterações
                    </span>
                </PrimaryButton>}
            onSubmit={hookFormCadastro.handleSubmit(onSubmit)}>

            <FormContainer title={"Informações"} arrangement="fullRow">
                <>
                    <DefaultFormInput
                        name='ordem'
                        label='Ordem'
                        readOnly={false}
                        required={true}
                        reactHookForm={hookFormCadastro}

                    />

                    <DefaultFormInput
                        name={'descricao'}
                        label="Ambiente"
                        readOnly={false}
                        required={true}
                        multiline={true}
                        rows={5}
                        minRows={4}
                        maxRows={10}
                        reactHookForm={hookFormCadastro}
                    />

                </>
            </FormContainer>
        </BaseFormControlledModal>
    );
}